import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import commonReq from '@/utils/request.js'
import check from '@/utils/check.js'
import store from './store'
// 富文本组件
import QuillRich from "@/components/QuillRich.vue"
import VideoPlayer from 'vue-video-player'

//引入样式
// import 'vue-video-player/src/custom-theme.css'
// import 'video.js/dist/video-js.css'
// import 'videojs-contrib-hls'
//使用组件
Vue.use(VideoPlayer)
Vue.use(ElementUI); 
Vue.config.productionTip = false
// 全局方法挂载
Vue.prototype.$commonReq=commonReq
Vue.prototype.check=check

// 全局组件挂载
Vue.component('QuillRich', QuillRich)

new Vue({
	router,
	store,
  render: h => h(App),
}).$mount('#app')
if (process.env.NODE_ENV !== 'production') {
	// console.log = () => {}//开发环境去除看一下效果
}else{
	//正式环境去除
	console.log = () => {}
	
}

